import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollVariableHistoryEntryDTO  {
    _originalTypeClassName = "zERP.BO.PayrollVariableHistoryEntryDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollVariableHistoryEntryDTO.translate = translateService;
}
this.ValidFrom = null;
this.VariableName = null;
this.VariableId = null;
this.PayrollVariableHistoryEntryDTOKey = null;
this._key = this.PayrollVariableHistoryEntryDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
ValidFrom:any;
VariableName:any;
VariableId:any;
private _PayrollVariableHistoryEntryDTOKey:any;
get PayrollVariableHistoryEntryDTOKey(): any {
    return this._PayrollVariableHistoryEntryDTOKey;
  }
set PayrollVariableHistoryEntryDTOKey(value: any) {
    this._PayrollVariableHistoryEntryDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollVariableHistoryEntryDTOKey == null || $this.PayrollVariableHistoryEntryDTOKey == 0;
            }


}